import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dashIfZero'
})
export class DashIfZeroPipe implements PipeTransform {
  transform(value: string): any {
    const cleanedValue = value.replace(/,/g, ''); // removes currency symbols or commas if any
    const numericValue = Number(cleanedValue);

    if (numericValue === 0 || numericValue === null || numericValue === undefined  || isNaN(numericValue)) {
      return '-';
    } else {
      return value;
    }
  }
}
